import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../../shared/services/auth.service";

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    router.navigate(["/login"]);
    return false;
  }

  const requiredRoles = route.data?.["roles"] as string[] | undefined;

  if (requiredRoles) {
    const userRoles = authService.getUserRole();
    if (
      !requiredRoles.some((requiredRole) => userRoles.includes(requiredRole))
    ) {
      router.navigate(["/unauthorized"]);
      return false;
    }
  }

  return true;
};
